import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import moment from 'moment'
import PropTypes from 'prop-types'
import { useIntl } from 'react-intl'
import EditOutlinedIcon from '@material-ui/icons/EditOutlined'
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline'
import { MenuList, MenuItem, Typography } from '@material-ui/core'

import { mapNumToBool } from 'commons/boolean'
import { getHumanizeDate } from 'commons/date'
import { resizeAvatar_80 } from 'commons/resizeImage'
import { useUserProfile } from 'commons/useUserProfile'

import MoreVertMenu from 'app/componentV4/Menu/MoreVertMenu'
import AvatarsWithLable from 'app/componentV4/Avatar/AvatarsWithLable'

const Creator = (props) => {
  const {
    onEdit,
    creator,
    editable,
    disabled,
    onDelete,
    createdAt,
    updatedAt,
    commentStatus,
  } = props
  const {
    avatar,
    lastname,
    firstName,
    id: creatorId,
    avatarCharacters,
    status: creatorStatus,
  } = creator

  const userData = useUserProfile()
  const { formatMessage } = useIntl()
  const [isDefaultAvatar, setIsDefaultAvatar] = useState(false)

  useEffect(() => {
    setIsDefaultAvatar(
      !mapNumToBool(creatorStatus) || !mapNumToBool(commentStatus),
    )
  }, [commentStatus, creatorStatus])

  return (
    <div className="flex space-x-3 justify-between">
      <AvatarsWithLable
        id={creatorId}
        name={`${firstName} ${lastname}`}
        src={isDefaultAvatar ? null : resizeAvatar_80(avatar)}
        characters={isDefaultAvatar ? null : avatarCharacters}
        className="text-14 font-bold"
      >
        <div>
          <div className="flex items-baseline space-x-3">
            {mapNumToBool(commentStatus) ? (
              <Typography
                className={clsx(
                  mapNumToBool(creatorStatus)
                    ? 'text-14 font-500 text-primary'
                    : 'text-14 font-500 text-primary-300 line-through',
                )}
              >
                {`${creator.firstName} ${creator.lastname}`}
              </Typography>
            ) : (
              <Typography className="text-14 font-400 text-primary-300">
                {formatMessage({
                  id: 'timeline.detail.message.comment.deleted',
                })}
              </Typography>
            )}
            {mapNumToBool(creatorStatus) ? null : (
              <Typography className="text-primary-300 text-12">
                {`(${formatMessage({
                  id: 'deleted.user.label',
                })})`}
              </Typography>
            )}
          </div>
          <div className="flex items-baseline space-x-3">
            <Typography className="text-primary-300 text-12 ">
              {getHumanizeDate(updatedAt)}
            </Typography>
            {moment(createdAt).isSame(updatedAt) ||
            !mapNumToBool(commentStatus) ||
            !mapNumToBool(creatorStatus) ? null : (
              <Typography className="text-primary-300 text-12 ">
                {`(${formatMessage({
                  id: 'edited.label',
                })})`}
              </Typography>
            )}
          </div>
        </div>
      </AvatarsWithLable>
      {mapNumToBool(editable) && userData.id === creatorId ? (
        <MoreVertMenu
          icon="more_horiz_outlined"
          className="p-3 text-primary-300"
          disabled={disabled}
        >
          {(closeMenu) => (
            <MenuList className="w-fit">
              <MenuItem
                onClick={() => {
                  onEdit()
                  closeMenu()
                }}
                className="space-x-5"
              >
                <EditOutlinedIcon fontSize="small" className="text-primary" />
                <Typography className="text-14 font-400 text-primary">
                  {formatMessage({
                    id: 'edit.label',
                  })}
                </Typography>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  onDelete()
                  closeMenu()
                }}
                className="space-x-5"
              >
                <DeleteOutlineIcon fontSize="small" className="text-red-500" />
                <Typography className="text-14 font-400 text-red-500">
                  {formatMessage({
                    id: 'action.delete',
                  })}
                </Typography>
              </MenuItem>
            </MenuList>
          )}
        </MoreVertMenu>
      ) : null}
    </div>
  )
}

Creator.propTypes = {
  onEdit: PropTypes.func,
  disabled: PropTypes.bool,
  onDelete: PropTypes.func,
  editable: PropTypes.number,
  updatedAt: PropTypes.string,
  createdAt: PropTypes.string,
  commentStatus: PropTypes.number,
  creator: PropTypes.shape({
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastname: PropTypes.string,
    avatar: PropTypes.string,
    avatarCharacters: PropTypes.string,
    deletedAt: PropTypes.string,
    status: PropTypes.number,
  }),
}

export default Creator
